const STORAGE_KEY = 'sshop:auth-token';

const isBrowser = (): boolean =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export function getAuthToken(): string | null {
  if (!isBrowser()) return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value !== null && value !== '' ? value : null;
  } catch {
    return null;
  }
}

export function setAuthToken(token: string | null): void {
  if (!isBrowser()) return;
  try {
    if (token === null || token === '') {
      window.localStorage.removeItem(STORAGE_KEY);
    } else {
      window.localStorage.setItem(STORAGE_KEY, token);
    }
  } catch {
    /* ignore */
  }
}
